export default {
  de: {
    district: 'Bezirk',
    city: 'Gemeinde',
    type: 'Funktion',
    name: 'Name',
    party: 'Partei',
    birthdate: 'Geburtsdatum',
    email: 'Email',
    phone: 'Telefon',
    mail: 'Post',
    since: 'Im Amt Seit',
  },
};
